export default "__VITE_ASSET__BlhYDqKZ__"